import React from 'react';
import { SVGIconProps } from '../../domains/common';

const TikTokIcon: React.FC<SVGIconProps> = ({ colored, ...rest }) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 -4 22 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M17.0346 16.0631V7.2748C19.0647 8.53013 21.5016 9.20299 24 9.19802V5.85335C22.524 5.58467 21.1893 4.90968 20.1972 3.93013C19.4048 3.48833 18.7252 2.91199 18.1998 2.23628C17.6744 1.56057 17.3142 0.799665 17.1413 0H13.4745V17.3093C13.4388 18.0627 13.1316 18.7879 12.5958 19.3839C12.06 19.98 11.322 20.4174 10.4845 20.6353C9.64697 20.8533 8.75149 20.8409 7.9225 20.6C7.0935 20.359 6.37217 19.9015 5.85874 19.291C5.02774 18.9139 4.36686 18.3082 3.98117 17.5701C3.59548 16.8321 3.50714 16.0041 3.73018 15.2178C3.95323 14.4315 4.47486 13.7321 5.21213 13.2307C5.94939 12.7293 6.85997 12.4548 7.79907 12.4508C8.22024 12.454 8.63859 12.5104 9.04082 12.6181V9.27327C7.2564 9.29935 5.51934 9.77238 4.04142 10.6347C2.56351 11.497 1.4086 12.7113 0.717515 14.1296C0.0264304 15.5479 -0.170971 17.1088 0.149379 18.6221C0.469729 20.1354 1.29399 21.5357 2.52166 22.6522C4.08097 23.5599 5.92761 24.0301 7.80887 23.9985C12.8965 23.9985 17.0239 20.4483 17.0346 16.0631Z"
        fill={colored ? 'black' : '#365284'}
      />
    </svg>
  );
};

export default TikTokIcon;
